export enum SashVariations {
    clearance = "clearance",
    sale = "sale",
    offer = "offer",
}

export const getSashAltText = (url: string | null, altText: string) => {
    const transform = (s: string) => `${s.charAt(0).toUpperCase() + s.slice(1)} ${altText}`
    const urlLower = url?.toLowerCase()
    if (urlLower?.includes(SashVariations.clearance)) return transform(SashVariations.clearance)
    if (urlLower?.includes(SashVariations.offer)) return transform(SashVariations.offer)
    return transform(SashVariations.sale)
}
